import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';

@customElement('specsheet-featuregroup')
export class SpecsheetFeaturegroup extends LitElement {

	static styles = css`
	  :host {
		display: block;
	  }

	  @media print {

	  }
	`;

	render() {
		return html`
			<slot>features</slot>
		`;
	}
}
